import { CancelToken } from 'axios';
import { DefaultState, MassAddResponse, MassAddRow } from 'store/types';

export const LODGING_OPTION_MASS_ADD_DATA_REQUEST = 'LODGING_OPTION_MASS_ADD_DATA_REQUEST';
export const LODGING_OPTION_MASS_ADD_DATA_SUCCESS = 'LODGING_OPTION_MASS_ADD_DATA_SUCCESS';
export const LODGING_OPTION_MASS_ADD_DATA_FAILURE = 'LODGING_OPTION_MASS_ADD_DATA_FAILURE';

export interface LodgingOptionMassAddRow extends MassAddRow {
  name: string;
  type: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  checkInDetails: string;
  checkOutDetails: string;
  notes: string;
  website: string;
  lodgingManagerName: string;
  lodgingManagerPhoneNumber: string;
  lodgingManagerEmail: string;
}

export interface LodgingOptionMassAddParams {
  data: FormData;
  onUploadProgress: (progressEvent: any) => void;
  cancelToken: CancelToken;
};

export type LodgingOptionMassAddData = MassAddResponse<LodgingOptionMassAddRow>

export type LodgingOptionMassAddState = DefaultState & {
  contents?: LodgingOptionMassAddData;
};

interface LodgingOptionMassAddDataRequest {
  type: typeof LODGING_OPTION_MASS_ADD_DATA_REQUEST;
}

interface LodgingOptionMassAddDataSuccess {
  type: typeof LODGING_OPTION_MASS_ADD_DATA_SUCCESS,
  contents: LodgingOptionMassAddData;
}

interface LodgingOptionMassAddDataFailure {
  type: typeof LODGING_OPTION_MASS_ADD_DATA_FAILURE;
}

export type LodgingOptionMassAddActionTypes = LodgingOptionMassAddDataRequest | LodgingOptionMassAddDataSuccess | LodgingOptionMassAddDataFailure;